import './App.css';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';
import logoltflarge from './images/ltf.png';
import Header from './Header';
import Footer from './Footer';
import { Link } from 'react-router-dom';

function NotFound() {

  return (
    <ThemeProvider theme={theme}>
      <div className="App">
        <Header />
        <section className="main-section" style={{ backgroundColor: '#FFFFFF', color: '#001C29' }}>
        <div className="logo-container">
        <Link to="/">
            <img src={logoltflarge} alt="logo" className="logo-img" style={{ height: 'auto' }} />
        </Link>
        </div>
        </section>
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default NotFound;
